<template>

    <v-card color="grey darken-2" class="mr-2 mt-2" width="300" height="120">

        <div class="d-flex flex-row pa-2">
            <v-card width="100" height="100" color="white">
                <v-img contain :src="cdnBaseUrl('img/paypal-logo.png')"></v-img>
            </v-card>

            <stat-box-numerical
                                class="ml-2"
                                :value="reward.cost"
                                :elevation="0"
                                :prefix="prefix"
                                :animate="false"
                                :hint="reward.cost_currency">
            </stat-box-numerical>
        </div>

    </v-card>

</template>

<script>

    import StatBoxNumerical from "../../../../components/UI/StatBoxNumerical";

    export default {

        components: {
            StatBoxNumerical,
        },

        props: {
            reward: {
                required: true,
                type: Object,
            }
        },

        computed: {

            prefix() {
                if (this.reward.currency === "USD") {
                    return '$';
                }
                if (this.reward.currency === "GBP") {
                    return '£';
                }
                if (this.reward.currency === "EUR") {
                    return '€';
                }
            },
        }
    }
</script>
